module.exports = __webpack_public_path__ + "static/hero_bg@2x-de0bae70c2d9c5023a701a763ded5bef.jpg";